import { View } from 'react-native';
import { MasonryItemProps } from './MasonryItem.types';

export const MasonryItem = ({ itemStyle, children, onLayout }: MasonryItemProps) => {
  return (
    <View testID="masonry-item" style={[itemStyle, { maxWidth: '100%' }]} onLayout={onLayout}>
      {children}
    </View>
  );
};
